export default "__VITE_PUBLIC_ASSET__a93472bc__"